import type { Vault } from '@/types/vault'

type CuratorDisplayInfo = Pick<NonNullable<Vault['curator']>, 'name' | 'displayName'>

export function getCuratorDisplayName(curator: CuratorDisplayInfo) {
  return curator.displayName || curator.name
}

export function getCuratorDisplayData(curator: CuratorDisplayInfo) {
  const names = curator.name.split('/')
  const displayName = getCuratorDisplayName(curator)
  const displayNames = displayName.split('/')
  const canMapDisplayNames =
    names.length === 1 ||
    (names.length === displayNames.length && displayNames.every((displayName) => Boolean(displayName.trim())))

  return {
    displayName,
    canMapDisplayNames,
    entries: names.map((name, index) => ({
      name,
      displayName: names.length === 1 ? displayName : canMapDisplayNames ? displayNames[index] || name : name,
    })),
  }
}
